import { init } from "./init";
import { sanitizeData, sanitizeExpire } from "./Sanitize";

const actionTypes = {
  FETCH_UPDATE_PASSWORD: "FETCH_UPDATE_PASSWORD",
};

const fetchUpdatePassword = async (state, updatepassword) => {
  state = {
    ...state,
    isStatus: updatepassword.status,
    expireToken: sanitizeExpire({
      status: updatepassword.status,
      data: updatepassword.data,
      name: "updatepasswordobj",
    }),
    data: sanitizeData({
      status: updatepassword.status,
      data: updatepassword.data,
      name: "updatepasswordobj",
    }),
  };
  return state;
};

const reducer = (state, action) => {
  switch (action.type) {
    case actionTypes.FETCH_UPDATE_PASSWORD:
      return fetchUpdatePassword(state, action.updatepassword);
    default:
      return state;
  }
};

const updatepassword = {
  init,
  actionTypes,
  reducer,
};

export default updatepassword;
